export default {
  title: "Подтверждаем Ваш E-mail...",
  successMessage: "Ваш E-mail подтвержден.",
  userNotFound: "Пользователь не найден.",
  incorrentCode: "Неверный код подтверждения.",
  serverError: "Ошибка сервера."
};
